
<template>
    <div>
        <template v-if="programsLoading">
            <loading :show="programsLoading"/>
        </template>
        <template v-else>
            <b-row>
                <b-col cols="12"  :lg="isPublic?'12':'6'" :md="isPublic?'12':'6'" :xl="isPublic?'12':'6'"  v-for="item in programs" :key="item.id" class="p-4 rounded-lg shadow-sm mb-4 bg-white hover-shadow transition">
                    <h4 class="d-none d-md-block font-weight-bold mb-3 height-50">{{ item.name }}</h4>
                    <h6 class="d-block d-md-none font-weight-bold mb-3 height-50 h6">{{ item.name }}</h6>
                    <div class="divider mb-2"></div>
                    <b-row class="mb-4">
                        <b-col cols="12" md="6" class="mb-3 mb-md-0">
                            <div class="date-card date-card--application">
                                <div class="date-card__header">
                                    <i class="ri-file-list-3-line"></i>
                                    <span>{{ $t('application') }}</span>
                                </div>
                                <div class="date-card__body">
                                    <div class="date-card__item">
                                    <span class="date-card__label">
                                        <i class="ri-calendar-check-line"></i>
                                        {{ $t('start_date') }}
                                    </span>
                                        <strong class="date-card__value">{{ toLocaleDate(item.application_start_date) }}</strong>
                                    </div>
                                    <div class="date-card__divider"></div>
                                    <div class="date-card__item">
                                    <span class="date-card__label">
                                        <i class="ri-calendar-close-line"></i>
                                        {{ $t('end_date') }}
                                    </span>
                                        <strong class="date-card__value">{{ toLocaleDate(item.application_end_date) }}</strong>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="12" md="6">
                            <div class="date-card date-card--certificate">
                                <div class="date-card__header">
                                    <i class="ri-award-line"></i>
                                    <span>{{ $t('certificate') }}</span>
                                </div>
                                <div class="date-card__body">
                                    <div class="date-card__item">
                                    <span class="date-card__label">
                                        <i class="ri-calendar-check-line"></i>
                                        {{ $t('start_date') }}
                                    </span>
                                        <strong class="date-card__value">{{ toLocaleDate(item.start_date) }}</strong>
                                    </div>
                                    <div class="date-card__divider"></div>
                                    <div class="date-card__item">
                                    <span class="date-card__label">
                                        <i class="ri-calendar-todo-line"></i>
                                        {{ $t('end_date') }}
                                    </span>
                                        <strong class="date-card__value">{{ toLocaleDate(item.end_date) }}</strong>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                        <b-col class="mt-2">
                            <div class="d-flex justify-content-center align-items-center date-card__item">
                                 <span class="date-card__label">
                                    <i class="ri-money-dollar-circle-line"></i>
                                    {{ $t('price') }}
                                </span>
                                <strong class="date-card__value">{{currencyFormat (item.price) }}</strong>
                            </div>
                        </b-col>
                    </b-row>
                    <div v-if="item.status">
                        <div :class="`alert ${item.status==='pending'?'alert-warning':'alert-success'}`" role="alert">
                            <i class="ri-refund-2-line align-middle text-primary mr-2"></i>
                            <span class="text-muted">{{ $t('payment_status') }}</span>
                            <strong class="ml-1">: {{getLocaleText(item,'status_name')}}</strong>
                        </div>

                    </div>
                    <b-button v-if="!item.applied && !isPublic" variant="info" block @click="applyForProgram(item)">{{ $t('apply') }}</b-button>
                    <div v-if="item.applied && item.status !== 'paid' && item.status !== 'approved'" class="mt-4 pt-3 border-top">
                        <h5 class="mb-3 font-size-14 text-muted text-center">{{ $t('pay_type') }}</h5>
                        <b-row>
                            <b-col cols="12" md="6" class="mb-3 mb-md-0">
                                <b-button variant="primary" block @click="payWithCreditCard(item)">{{$t('online_credit_card')}}</b-button>
                            </b-col>
                            <b-col cols="12" md="6">
                                <b-button variant="outline-success" block @click="item.showHavale = !item.showHavale">{{$t('money_order')}}</b-button>
                            </b-col>
                        </b-row>

                        <b-collapse :id="'havale-info-' + item.id" v-model="item.showHavale" class="mt-4">
                            <div class="border p-4 rounded-sm bg-light">
                                <div class="d-flex justify-content-between align-items-center mb-4">
                                    <h6 class="text-primary font-weight-bold m-0">{{$t('account_information')}}</h6>
                                    <b-badge variant="secondary">{{$t('BAU')}}</b-badge>
                                </div>

                                <b-row class="mb-3 border-bottom pb-2">
                                    <b-col cols="4" class="text-muted font-size-12 font-weight-bold">{{$t('bank_name')}}</b-col>
                                    <b-col cols="8" class="text-right font-weight-bold">{{eftInformation?.bankaAdi}}</b-col>
                                </b-row>
                                <b-row class="mb-3 border-bottom pb-2">
                                    <b-col cols="4" class="text-muted font-size-12 font-weight-bold">{{$t('receiver')}}</b-col>
                                    <b-col cols="8" class="text-right font-weight-bold">{{eftInformation?.alici}}</b-col>
                                </b-row>
                                <b-row class="mb-3 align-items-center">
                                    <b-col cols="4" class="text-muted font-size-12 font-weight-bold">{{$t('iban')}}</b-col>
                                    <b-col cols="8" class="text-right font-weight-bold text-primary font-size-16">
                                        {{eftInformation?.iban}}
                                    </b-col>
                                </b-row>

                                <b-alert variant="info" show class="mt-4 font-size-12 mb-0">
                                    <i class="ri-information-fill mr-2"></i> <div v-html="$t('ulmer_payment_note')">
                                </div>
                                </b-alert>
                            </div>
                        </b-collapse>
                    </div>
                </b-col>
            </b-row>
        </template>
    </div>
</template>

<script>
import UlmerCertificatesApplicationsServices from "@/services/UlmerCertificatesApplicationsServices";
import ConstantService from "@/services/ConstantService";

export default {
    name: "Programs",
    props:{
      isPublic:{
          type:Boolean,
          default:false
      }
    },
    data(){
        return {
            programsLoading:false,
            programs:[],
            myApplications:[],
            eftInformation:{},
        }
    },
    created() {
      this.getPrograms()
      if(!this.isPublic) this.getEftInformation()
    },
    methods:{
        async getPrograms(){
            try {
                this.programsLoading=true
                const applications =await UlmerCertificatesApplicationsServices.programs()
                this.programs=applications.data.data.map((item)=>{
                    return {
                        ...item,
                        applied:false
                    }
                })
                if (!this.isPublic){
                    const token =this.$store.getters['UlmerCertificatesApplication/getToken']
                    const myApplications =await UlmerCertificatesApplicationsServices.myApplicationList({token:token})
                    this.myApplications=myApplications.data.data
                    if (this.myApplications && this.myApplications.length > 0){
                        this.programs=this.programs.map((item)=>{
                            const findApplicationsStatus =this.myApplications.find(app=>app.certificate_id===item.id)
                            if (findApplicationsStatus){
                                return {
                                    ...item,
                                    applied:true,
                                    price:findApplicationsStatus.price??0,
                                    status:findApplicationsStatus.status??'',
                                    status_name:findApplicationsStatus.status_name,
                                    status_name_en:findApplicationsStatus.status_name_en
                                }
                            }else{
                                return item
                            }
                        })
                    }
                }
            }catch (error) {
                this.showErrors(error,null)
            }finally {
                this.programsLoading=false
            }
        },
        applyForProgram(item) {
            this.$swal.fire({
                    text: this.$t('are_you_sure_to_ticket_approved'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no')
                })
                .then(async (result) => {
                    if (result.isConfirmed) {
                        try {
                            const token =this.$store.getters['UlmerCertificatesApplication/getToken']
                            await  UlmerCertificatesApplicationsServices.makeApplication({certificate_id:item.id,token:token})
                            this.$toast.success(this.$t('proccess_success'))
                            await this.getPrograms()

                        }catch (err){
                          this.showErrors(err,null)
                        }
                    }
                })
        },
        payWithCreditCard() {
            window.open('https://umis.bau.edu.tr/epayment/login', '_blank');
        },
        getEftInformation(){
            const data={
                params:{
                    key:'ulmer_application.eft_information'
                }
            }
            ConstantService.getValue(data).then(response => {
                if (response.data.data){
                    this.eftInformation=JSON.parse(response.data.data)
                }

            }).catch(e => {
                this.showErrors(e)
            })
        }
    }
}
</script>


<style scoped>
/* ── Date Cards ──────────────────────────────────── */
.date-card {
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid #e9ecef;
    height: 100%;
}

.date-card__header {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 14px;
    font-size: 12px;
    font-weight: 700;
    color: #fff;
    letter-spacing: 0.3px;
}

.date-card__header i {
    font-size: 15px;
}

/* Başvuru – mavi ton */
.date-card--application .date-card__header {
    background: linear-gradient(135deg, #3a7bd5, #3a9dce);
}

/* Sertifika – yeşil ton */
.date-card--certificate .date-card__header {
    background: linear-gradient(135deg, #11998e, #38ef7d);
    color: #fff;
}

.date-card__body {
    display: flex;
    flex-direction: column;
    padding: 10px 14px;
    background-color: #f8f9fa;
    gap: 8px;
}

.date-card__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
}

.date-card__label {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 11.5px;
    color: #6c757d;
    white-space: nowrap;
}

.date-card__label i {
    font-size: 13px;
    flex-shrink: 0;
}

.date-card__value {
    font-size: 13px;
    font-weight: 700;
    white-space: nowrap;
    color: #343a40;
}

.date-card__divider {
    height: 1px;
    background-color: #dee2e6;
    width: 100%;
}

@media (max-width: 575px) {
    .date-card__label {
        font-size: 10.5px;
    }

    .date-card__value {
        font-size: 12px;
    }

    .date-card__body {
        padding: 8px 10px;
    }
}
</style>
